module.exports = __webpack_public_path__ + "img/step_phone1.b3c4de36.png";